<template>
  <div>
    <AppBar />
    <v-main class="h-screen-max grey lighten-5">
      <v-container class="pt-8 h-full d-flex flex-column justify-center text-center">
        <h1 class="text-h4">This case has been canceled.
          <v-icon large color="error" class="ml-2">do_disturb_alt</v-icon>
        </h1>
        <v-btn
          v-if="!insideIframe"
          color="primary"
          to="/cases"
          class="w-max mx-auto py-4"
        >Back to Home</v-btn>
      </v-container>
    </v-main>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import AppBar from '@/components/layout/AppBar.vue';

export default {
  name: 'CaseCanceledPage',
  components: {
    AppBar,
  },
  computed: {
    ...mapState({
      insideIframe: (state) => state.layout.insideIframe,
    }),
  },
};
</script>

<style lang="scss" scoped>
.rotate {
  animation: rotate 2s linear infinite;
}

@keyframes rotate {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.h-screen-max {
  height: 100vh;
}

.h-full {
  height: 100%;
}

.w-max {
  width: max-content;
}
</style>
